document.addEventListener("DOMContentLoaded", function () {
  const overlay = createOverlay();
  document.body.appendChild(overlay);

  const imgEl = overlay.querySelector(".lightbox-image");
  const countEl = overlay.querySelector(".lightbox-count");

  let currentIndex = 0;
  let currentImages = [];
  let touchStartX = 0;
  let touchEndX = 0;

  // Initialize all lightbox groups
  document.querySelectorAll(".lightbox").forEach((group) => {
    const images = group.querySelectorAll("[data-lightbox-image]");
    const imageArray = Array.from(images).map((img) => img.dataset.lightboxImage);

    images.forEach((img, index) => {
      img.addEventListener("click", (e) => {
        e.preventDefault();
        openLightbox(imageArray, index);
      });
    });
  });

  function createOverlay() {
    const el = document.createElement("div");
    el.className = "lightbox-overlay";
    el.innerHTML = `
      <div class="lightbox-content">
        <div class="lightbox-spinner"><i class="fa fa-spinner"></i></div>
        <div class="lightbox-error">
          <i class="fa fa-exclamation-triangle"></i>
          <span>Obrázek se nepodařilo načíst</span>
        </div>
        <img class="lightbox-image" src="" alt="" data-loading="idle" />
        <div class="lightbox-count"></div>
      </div>
      <button class="lightbox-close" aria-label="Zavřít"><i class="fa fa-xmark"></i></button>
      <button class="lightbox-prev" aria-label="Předchozí"><i class="fa fa-chevron-left"></i></button>
      <button class="lightbox-next" aria-label="Další"><i class="fa fa-chevron-right"></i></button>
    `;

    el.querySelector(".lightbox-close").onclick = closeLightbox;
    el.querySelector(".lightbox-prev").onclick = () => changeImage(-1);
    el.querySelector(".lightbox-next").onclick = () => changeImage(1);
    el.onclick = (e) => {
      if (e.target === el) closeLightbox();
    };

    // Touch swipe support
    el.addEventListener("touchstart", (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    el.addEventListener("touchend", (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    return el;
  }

  function handleSwipe() {
    const diff = touchStartX - touchEndX;
    const threshold = 50;

    if (Math.abs(diff) < threshold) return;
    if (currentImages.length <= 1) return;

    if (diff > 0) {
      changeImage(1); // Swipe left → next
    } else {
      changeImage(-1); // Swipe right → prev
    }
  }

  function openLightbox(images, index) {
    currentImages = images;
    currentIndex = index;

    overlay.classList.toggle("single-image", images.length <= 1);
    updateImage();
    overlay.classList.add("active");
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", keyControls);
  }

  function closeLightbox() {
    overlay.classList.remove("active");
    document.body.style.overflow = "";
    document.removeEventListener("keydown", keyControls);
  }

  function changeImage(offset) {
    currentIndex = (currentIndex + offset + currentImages.length) % currentImages.length;
    updateImage();
  }

  function updateImage() {
    const newSrc = currentImages[currentIndex];

    // Set loading state
    imgEl.dataset.loading = "loading";
    overlay.classList.add("is-loading");
    overlay.classList.remove("is-error");

    // Preload image
    const preloader = new Image();

    preloader.onload = () => {
      imgEl.src = newSrc;
      imgEl.dataset.loading = "loaded";
      overlay.classList.remove("is-loading");
    };

    preloader.onerror = () => {
      imgEl.dataset.loading = "error";
      overlay.classList.remove("is-loading");
      overlay.classList.add("is-error");
    };

    preloader.src = newSrc;

    // Update counter
    countEl.textContent = `${currentIndex + 1} / ${currentImages.length}`;
  }

  function keyControls(e) {
    if (e.key === "ArrowRight") changeImage(1);
    if (e.key === "ArrowLeft") changeImage(-1);
    if (e.key === "Escape") closeLightbox();
  }
});
